import { useEffect, useState } from "react";
import { axiosInstance } from "../../utility/apiInstance";
import { useRole } from "../MangeContextProvide";
import { useSocket } from "../../context/SocketContext";


function CreditVisibility({ ocean = "", air = "", whatsApp = "", licenses = "" }) {
  const [balance, setBalance] = useState({
    air: 0,
    ocean: 0,
    whatsApp: 0,
    licenses: 0
  });
  const { organizationId ,setAvailabeCredit} = useRole() as any;
  const [remainingLicenses, setRemainingLicenses] = useState(0);
 
  const socket = useSocket();

  const fetchBalance = async () => {
    if (!organizationId) {
      return;
    }

    try {
      let endpoint;
      if (air === "air") {
        endpoint = `/api/v1/credit-transaction/${organizationId}`;
      } else if (licenses == "licenses") {
        endpoint = `/api/v1/organisation/licenses/${organizationId}`;
      } else if (ocean == "ocean") {
        endpoint = `/api/v1/container-credit/${organizationId}`;
      } else if (whatsApp == "whatsApp") {
        endpoint = `/api/v1/whatsapp-credit/${organizationId}`;
      }

      if (endpoint) {
        const response = await axiosInstance.get(endpoint);
        const closingBalance = response.data?.data?.closingBalance;

        if (licenses === "licenses") {
          setRemainingLicenses(
            response.data?.data?.customerOrganization?.remainingLiecence
          );
        }
        if (whatsApp === "whatsApp") {
          const formattedBalance = closingBalance?.toFixed(2) || "0.00";
          setBalance((prev) => ({ ...prev, whatsApp: formattedBalance }));
        } else if (ocean === "ocean") {
          const formattedBalance = closingBalance?.toFixed(2) || "0.00";
          setBalance((prev) => ({ ...prev, ocean: formattedBalance }));
        } else if (air === "air") {
          const formattedBalance = closingBalance?.toFixed(2) || "0.00";
          setAvailabeCredit(Number(formattedBalance));
          setBalance((prev) => ({ ...prev, air: formattedBalance }));
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (!socket) return;

    socket.on("creditUpdate", (creditUpdate) => {
     
      if (whatsApp === "whatsApp") {
        const formattedBalance = creditUpdate.whatsapp.closingBalance?.toFixed(2) || "0.00";
        setBalance((prev) => ({ ...prev, whatsApp: formattedBalance }));
      } else if (ocean === "ocean") {
        const formattedBalance = creditUpdate.ocean.closingBalance?.toFixed(2) || "0.00";
        setBalance((prev) => ({ ...prev, ocean: formattedBalance }));
      } else if (air === "air") {
        const formattedBalance = creditUpdate.air.closingBalance?.toFixed(2) || "0.00";
        setAvailabeCredit(Number(formattedBalance));
        setBalance((prev) => ({ ...prev, air: formattedBalance }));
      }

    });

    return () => {
      socket.off("creditUpdate");

    };
  }, [socket]);


  useEffect(() => {
    fetchBalance();
  }, [organizationId, whatsApp, licenses, air, ocean, remainingLicenses]);

  if (whatsApp === "whatsApp") {

    return <div className="flex flex-col">{balance.whatsApp}</div>;
  } else if (ocean === "ocean") {

    return <div className="flex flex-col">{balance.ocean}</div>;
  } else if (air === "air") {
    return <div className="flex flex-col">{balance.air}</div>;
  } else {
    return <div className="flex flex-col">{remainingLicenses}</div>;
  }

}

export default CreditVisibility;